var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "head",
                                      attrs: { cols: "12" }
                                    },
                                    [_c("h4", [_vm._v(":: Contacto")])]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "breadcrumb",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            to: { name: "SupervisorContacts" }
                                          }
                                        },
                                        [_vm._v("Contacto")]
                                      ),
                                      _vm._v(
                                        " » " +
                                          _vm._s(_vm.contact.fullname) +
                                          ":\n                    "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pb-2 cliente-detalle mb-4" },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-left pr-4 pl-4",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c("label", [_vm._v("Nombre:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.fullname))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Teléfono:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.phone))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Email:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.email))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Tienda:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.store))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Marca:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.brand))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Asunto:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.subject))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Mensaje:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.message))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Términos:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.contact.terms))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Creado en:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.contact.created_at)
                                            )
                                          ]),
                                          _c("br")
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "my-4" }),
                                  _vm._v(" "),
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "success" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.editcontact(
                                            _vm.contact._id,
                                            _vm.contact.brand
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Editar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.deletecontact(
                                            _vm.contact._id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Eliminar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cad0368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cad0368","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supervisor/ShowContact.vue
// module id = null
// module chunks = 